<script>
export default {
  name: "EventSchedule",
  props: {
    schedule: {
      type: Array,
      required: true,
    },
  },
}
</script>

<template>
  <v-simple-table class="mt-10">
    <template v-slot:default>
      <thead class="light-grey-row">
        <tr class="light-grey-row">
          <th class="black--text">Thema</th>
          <th class="black--text">Referent:in</th>
          <th class="black--text">Uhrzeit</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in schedule" :key="index" :class="index % 2 === 0 ? 'dark-grey-row' : 'light-grey-row'">
          <td>{{ item.Thema }}</td>
          <td>{{ item.Sprecher }}</td>
          <td>{{ item.Start.slice(0, 5) }} - {{ item.Ende.slice(0, 5) }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<style scoped>
.light-grey-row {
  background: #f2f2f3 !important;
}

.dark-grey-row {
  background-color: rgb(225, 225, 226);
}

td, th {
  border-bottom: unset !important;
}

th {
  font-size: 16px !important;
}
</style>